// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2dQf4","calendarButtons":"ClockData_calendarButtons__2iSUs"};